import * as React from 'react'

import { ContainerProps } from '@mui/material'

import HeaderBar, { HeaderBarHeightPixel } from 'components/atomic/organisms/header'
import ResponsiveContainer from 'components/atomic/organisms/responsive-container'
import SEO, { Breadcrumb } from 'components/atomic/atoms/simple-page-seo'
import HeaderOnlyLogo from 'components/atomic/organisms/header-only-logo'
import Footer from 'components/atomic/organisms/footer'

interface MainLayoutProps extends ContainerProps {
    title?: string
    description?: string
    breadcrumbs?: Breadcrumb[]

    children: React.ReactElement | React.ReactElement[]
    showHeader?: boolean
    showFooter?: boolean
    isFluid?: boolean
    style?: React.CSSProperties
    headerType?: 'default' | 'only-logo' | 'only-logo-lock'
}

const MainLayout = ({
    children,
    headerType,
    isFluid = false,
    showHeader = true,
    showFooter = true,
    title,
    description,
    breadcrumbs,
    ...props
}: MainLayoutProps) => {
    const marginTop = React.useMemo(() => (showHeader ? HeaderBarHeightPixel : 0), [showHeader])

    const Header = React.useMemo(() => {
        if (!showHeader) return null
        if (headerType === 'only-logo') return <HeaderOnlyLogo />
        if (headerType === 'only-logo-lock') return <HeaderOnlyLogo clickableLogo={false} />
        return <HeaderBar />
    }, [showHeader, headerType])

    return (
        <>
            {title && <SEO title={title} description={description} breadcrumbs={breadcrumbs} />}
            <ResponsiveContainer
                maxWidth={isFluid ? false : 'xl'}
                style={{ padding: isFluid ? 0 : undefined }}
                {...props}>
                {showHeader && Header}

                <div style={{ marginTop: `${marginTop}px`, marginBottom: '8rem' }}>{children}</div>

                {showFooter && <Footer />}
            </ResponsiveContainer>
        </>
    )
}

export default MainLayout
